import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon",
  style: {"width":"1em","height":"1em","vertical-align":"middle","fill":"currentColor","overflow":"hidden"}
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1))
}
export default { render: render }